export default __webpack_public_path__ + "static/media/Icono_Conferencias.ae4e6aaf.png";